export default __webpack_public_path__ + "static/11_37-5633c8521e39065e10b890ae1782a7d2.png";